import React, { useEffect, useRef } from "react";
import { useLoadScript, Autocomplete } from '@react-google-maps/api';
import ClientHeader from "../../client-header/components/index";
import ClientFooter from "../../client-footer/components/index";
import { getServiceTypes } from '../../client-services/slice/clientServicesSlice';
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from 'react-redux';

const ClientHome = () => {
  const carouselRef = useRef();
  const dispatch = useDispatch();
  const libraries = ['places'];
const autocompleteRef = useRef(null);
const navigate = useNavigate();

const { isLoaded } = useLoadScript({
  googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
  libraries,
});
  const { serviceTypes } = useSelector((state) => state.clientServices);

  useEffect(() => {
    dispatch(getServiceTypes());
  }, [dispatch]);

  console.log("serviceTypes", serviceTypes);

  useEffect(() => {
    if (window.$ && window.$.fn.owlCarousel && serviceTypes.length > 0) {
      const $ = window.$;
      const owl = $(carouselRef.current);

      // Destroy existing carousel if initialized
      if (owl.hasClass("owl-loaded")) {
        owl.trigger("destroy.owl.carousel");
        owl.find(".owl-stage-outer").children().unwrap();
        owl.removeClass("owl-loaded");
      }

      // Re-initialize carousel
      owl.owlCarousel({
        loop: true,
        margin: 20,
        nav: false,
        dots: false,
        autoplay: true,
        autoplayTimeout: 8000,
        responsive: {
          0: { items: 1 },
          500: { items: 2 },
          992: { items: 3 },
          1200: { items: 4 },
        },
      });

      $(".owl-prev").click(() => {
        owl.trigger("prev.owl.carousel");
      });

      $(".owl-next").click(() => {
        owl.trigger("next.owl.carousel");
      });
    }
  }, [serviceTypes]);

    return (
    <>
     <style>
      {`
        .get-started-button {
          width: 300px !important;
        }
        .card-hover {
  position: relative;
  overflow: hidden;
}

.card-hover::before {
  content: "";
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  top: 10%; /* <-- Increased height of overlay (was 50%) */
  background: linear-gradient(to top, rgba(0, 0, 0, 0.9), transparent);
  z-index: 1;
  pointer-events: none;
  border-radius: inherit;
}

.card-overlay {
  z-index: 1;
  padding-bottom: 5px !important;
}

      `}
    </style>
      <ClientHeader />
      <main className="overflow-hidden">
          <section className="home-banner position-relative">
            <div className="container">
              <div className="row">
                <div className="col-12">
                  <div className="hero-section row align-items-center">
                    {/* Left Column */}
                    <div className="col-lg-7 col-xl-7">
                      <div className="homebanner text-center text-lg-start">
                        <h1 className="montserrat font-weight-bold lh-1">
                          <p className="d-lg-block font-size-36">Smart Support for Every Child.</p>
                          {/* Simple Tools <span className="d-inline-block">for</span> */}
                          <p className="d-lg-block font-size-36">Simple Tools for Every Family.</p>
                        </h1>
                        <p className="my-3 my-xl-4 pb-lg-2 font-size-18">
                          {/* Helping families <span className="highlight font-weight-semibold">273,692</span> new jobs - 
                          <span className="highlight font-weight-semibold">11,119</span> added in the last 24 hours */}
                          Helping families and childcare centers identify and support developmental needs early — with secure, AI-powered tools and trusted professional connections
                        </p>
                        <div className="mt-4 d-flex flex-wrap gap-2 justify-content-center justify-content-lg-start">
                          <button className="btn btn-outline-light font-weight-semibold rounded outline-transition-button" onClick={() => {
                              const el = document.getElementById("how-it-work-anchor");
                              if (el) el.scrollIntoView({ behavior: "smooth" });
                            }}><span className="d-block py-sm-1 px-sm-2">Learn How It Works</span>
                          </button>
                          <Link to="/signup">
                            <button className="btn btn-outline-light font-weight-semibold rounded outline-transition-button"><span className="d-block py-sm-1 px-sm-2 button-text">Join As A Parent</span></button>
                          </Link>
                          <Link to="/provider/signup">
                            <button className="btn btn-outline-light font-weight-semibold rounded outline-transition-button"><span className="d-block py-sm-1 px-sm-2">Join As A Provider</span></button>
                          </Link>
                        </div>
                      </div>
                    </div>
                    {/* Right Column */}
                    <div className="col-lg-5 col-xl-5 mt-4 mt-lg-0 pt-md-3 pt-lg-0">
                      <div className="image-container position-relative text-center text-lg-end"><img src="/assets/images/banner-img.png" alt="Doctor Image" className="img-fluid w-100" /></div>
                    </div>
                    {/* Search Box */}
                    <div className="search-box">
                      {isLoaded && (
                        <>
                        <Autocomplete
                        className="w-100"
                          onLoad={(autocomplete) => (autocompleteRef.current = autocomplete)}
                          onPlaceChanged={() => {
                            const place = autocompleteRef.current.getPlace();
                            if (!place.geometry) return;

                            const lat = place.geometry.location.lat();
                            const lng = place.geometry.location.lng();
                            const address = place.formatted_address;

                            const locationDetails = {
                              address,
                              lat,
                              long: lng,
                              city: "",
                              state: "",
                              country: ""
                            };

                            const queryParams = new URLSearchParams(locationDetails).toString();

                            // ✅ Navigate to Component 2 with location in query params or state
                            window.open(`/client-services?${queryParams}`, '_blank');
                          }}
                        >
                      <input type="text" className="form-control me-2" placeholder="Zip Code Search by Location" />
                      </Autocomplete>
                      <i className="fa fa-search fs-5"></i>
                      </>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
          {/* <section className="homepad" id="about">
            <div className="container">
              <div className="row align-items-center">
                <div className="col-lg-6">
                  <div className="position-relative">
                    <img src="/assets/images/about-img.jpg" alt="..." className="w-100 about-img" />
                  </div>
                </div>
                <div className="col-lg-6 font-size-16 font-weight-normal line-hight-3 text-muted mt-4 mt-lg-0 pt-3 pt-lg-0">
                  <div className="ps-lg-4 ps-xl-5">
                    <div>
                      <div className="bg-primary-heading font-weight-semibold font-size-18 text-capitalize p-1 rounded-pill d-inline-block text-white pe-4"><span className="bg-yellow d-inline-block p-1 bg-primary-heading rounded-pill favicon-logo01 text-center me-2"><img src="/assets/images/favicon-logo01.svg" alt="..." className="rounded-circle" /></span>About Us</div>
                    </div>
                    <h2 className="font-weight-bold montserrat text-primary font-size-46 my-3 my-lg-4 py-xl-2 lh-1">Welcome, Parents & Caregivers
                    </h2>
                    <p>You are your child’s most powerful advocate—and you don’t have to navigate this journey alone.
                      At The Just Generation Foundation, we’re here to help you recognize your child’s unique needs early and connect with trusted professionals who can guide you forward.
                      Whether you're facing speech delays, behavioral concerns, or just a gut feeling that something isn’t quite right, our tools, referrals, and support resources are designed with you in mind.
                      Because every child deserves the best start—and every parent deserves the right support. <br />
                      🔵 Explore our screening tools, service providers, and family resources today.</p>

                    <h2 className="font-weight-bold montserrat text-primary font-size-46 my-3 my-lg-4 py-xl-2 lh-1">Welcome, Professionals & Educators
                    </h2>
                    <p>The early years matter—and so does your role in shaping them.
                        The Just Generation Foundation partners with therapists, educators, and healthcare professionals to deliver timely, effective support to families navigating developmental concerns.
                        Join our growing network of licensed experts dedicated to improving outcomes for children ages 2–5.
                        We offer streamlined onboarding, built-in verification, scheduling tools, billing integrations, and a referral-ready platform built with your practice in mind. <br />
                        🔵 Let’s work together to build a stronger, earlier support system—one child at a time.</p>
                    <div className="mt-4 pt-lg-2">
                      <a href="#mission" className="btn btn-custom-primary font-weight-medium font-size-18 text-capitalize px-3 px-md-4 rounded"><span className="d-block py-2">Learn More About Our Mission<img src="/assets/images/arrow-01.svg" alt="..." className="ms-2" /></span></a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section> */}
          {/* <section className="homepad" id="mission">
            <div className="container">
              <div className="row align-items-center">
                <div className="col-lg-6 font-size-16 font-weight-normal line-hight-3 text-muted mt-4 mt-lg-0 pt-3 pt-lg-0">
                  <div className="ps-lg-4 ps-xl-5">
                    <div>
                      <div className="bg-primary-heading font-weight-semibold font-size-18 text-capitalize p-1 rounded-pill d-inline-block text-white pe-4">
                        <span className="bg-yellow d-inline-block p-1 bg-primary-heading rounded-pill favicon-logo01 text-center me-2">
                          <img src="/assets/images/favicon-logo01.svg" alt="..." className="rounded-circle" />
                        </span>
                        Learn More About Our Mission
                      </div>
                    </div>
                    <h2 className="font-weight-bold montserrat text-primary font-size-46 my-3 my-lg-4 py-xl-2 lh-1">
                      At The Just Generation Foundation, our mission is simple yet transformative:
                    </h2>

                    <p>
                      To identify and support young children with developmental needs as early as possible, by building a unified national network of parents, caregivers, licensed professionals, and child care centers—powered by technology, trust, and compassion.
                    </p>
                    <p className="mt-3">
                      <strong>We believe:</strong><br />
                      - Every parent deserves a roadmap and trusted guidance<br />
                      - Every provider deserves tools to make a difference<br />
                      - Every child deserves a chance to thrive—regardless of zip code, income, or background
                    </p>
                    <p className="mt-3">
                      With smart automation, AI-powered matching, and a pre-screened provider referral system, we’re eliminating barriers and delays in early childhood intervention.
                    </p>
                    <p className="mt-3">
                      Whether you're a family navigating a first concern or a provider ready to serve more effectively, we’re here to connect the dots and build the future—together.
                    </p>
                                        <div className="mt-5">
                      <div className="bg-primary-heading font-weight-semibold font-size-18 text-capitalize p-1 rounded-pill d-inline-block text-white pe-4">
                        <span className="bg-yellow d-inline-block p-1 bg-primary-heading rounded-pill favicon-logo01 text-center me-2">
                          <img src="/assets/images/favicon-logo01.svg" alt="..." className="rounded-circle" />
                        </span>
                        Our Vision
                      </div>
                    </div>
                    <p className="mt-3">
                      We envision a world where no child is left waiting, where families are equipped with tools—not guesswork—and where communities are empowered to intervene early, effectively, and with compassion.
                      Together, we can build a Just Generation—one child, one family, one breakthrough at a time.
                    </p>
                  </div>
                </div>

                <div className="col-lg-6">
                  <div className="position-relative">
                    <img src="/assets/images/about-img.jpg" alt="..." className="w-100 how-it-work-img" />
                  </div>
                </div>
              </div>
            </div>
          </section> */}

          <section className="homepad" id="drive">
            <div className="container">
              <div className="row align-items-center">
                <div className="col-lg-6">
                  <div className="position-relative">
                    <img src="/assets/images/about-img.jpg" alt="..." className="w-100 about-img" />
                  </div>
                </div>
                <div className="col-lg-6 font-size-16 font-weight-normal line-hight-3 text-muted mt-4 mt-lg-0 pt-3 pt-lg-0">
                  <div className="ps-lg-4 ps-xl-5">
                    <div>
                      <div className="bg-primary-heading font-weight-semibold font-size-18 text-capitalize p-1 rounded-pill d-inline-block text-white pe-4">
                        <span className="bg-yellow d-inline-block p-1 bg-primary-heading rounded-pill favicon-logo01 text-center me-2">
                          <img src="/assets/images/favicon-logo01.svg" alt="..." className="rounded-circle" />
                        </span>
                        What Drives Us
                      </div>
                    </div>
                  
                   
                    <p className="mt-3">
                      <strong>
                        <span className="me-2 text-primary">✔</span> Early Identification:
                      </strong>
                      <br />
                      <span>
                        Research shows that the earlier we identify speech, behavioral, or developmental needs, the better the outcomes. That’s why we focus on early screening, support, and referrals during the most critical years of a child’s development.
                      </span>
                    </p>
                    <p className="mt-3">
                      <strong>
                        <span className="me-2 text-primary">✔</span> Empowered Families and Providers:
                      </strong>
                      <br />
                      <span>
                        We unite parents, caregivers, teachers, and medical professionals through our platform, providing AI-guided tools, training resources, and licensed providers to ensure no one falls through the cracks.
                      </span>
                    </p>
                    <p className="mt-3">
                      <strong>
                        <span className="me-2 text-primary">✔</span> Equity, Access, and Innovation:
                      </strong>
                      <br />
                      <span>
                        Every child—regardless of zip code, language, or income—deserves a chance to thrive. Our platform ensures access to culturally responsive tools, Medicaid/Medicare-integrated services, and a growing provider network tailored to local needs.
                      </span>
                    </p>

                    <div className="mt-5">
                      <div className="bg-primary-heading font-weight-semibold font-size-18 text-capitalize p-1 rounded-pill d-inline-block text-white pe-4">
                        <span className="bg-yellow d-inline-block p-1 bg-primary-heading rounded-pill favicon-logo01 text-center me-2">
                          <img src="/assets/images/favicon-logo01.svg" alt="..." className="rounded-circle" />
                        </span>
                        How We Work
                      </div>
                    </div>
                    <p className="mt-3">
                      <strong>
                        <span className="me-2 text-primary">✔</span> Technology-Driven Solutions:
                      </strong>
                      <br />
                      <span>
                        Our AI tools help screen and match children with the right providers and services.
                      </span>
                    </p>
                    <p className="mt-3">
                      <strong>
                        <span className="me-2 text-primary">✔</span> Real-Time Support:
                      </strong>
                      <br />
                      <span>
                        We offer virtual consults, on-demand educational webinars, and resource kits for both parents and professionals.
                      </span>
                    </p>
                    <p className="mt-3">
                      <strong>
                        <span className="me-2 text-primary">✔</span> Verified Provider Network:
                      </strong>
                      <br />
                      <span>
                        Every provider in our system is vetted, licensed, and aligned with best practices in early intervention.
                      </span>
                    </p>


                  </div>
                  
                </div>
                

                
              </div>
            </div>
          </section>

          {/* <section className="homepad" id="how-we-work">
            <div className="container">
              <div className="row align-items-center">
                <div className="col-lg-6 font-size-16 font-weight-normal line-hight-3 text-muted mt-4 mt-lg-0 pt-3 pt-lg-0">
                  <div className="ps-lg-4 ps-xl-5">
                    <div>
                      <div className="bg-primary font-weight-semibold font-size-18 text-capitalize p-1 rounded-pill d-inline-block text-white pe-4">
                        <span className="bg-yellow d-inline-block p-1 bg-primary rounded-pill favicon-logo01 text-center me-2">
                          <img src="/assets/images/favicon-logo01.svg" alt="..." className="rounded-circle" />
                        </span>
                        How We Work
                      </div>
                    </div>

                    <p className="mt-3">
                      <strong>
                        <span className="me-2 text-primary">✔</span> Technology-Driven Solutions:
                      </strong>
                      <br />
                      <span>
                        Our AI tools help screen and match children with the right providers and services.
                      </span>
                    </p>
                    <p className="mt-3">
                      <strong>
                        <span className="me-2 text-primary">✔</span> Real-Time Support:
                      </strong>
                      <br />
                      <span>
                        We offer virtual consults, on-demand educational webinars, and resource kits for both parents and professionals.
                      </span>
                    </p>
                    <p className="mt-3">
                      <strong>
                        <span className="me-2 text-primary">✔</span> Verified Provider Network:
                      </strong>
                      <br />
                      <span>
                        Every provider in our system is vetted, licensed, and aligned with best practices in early intervention.
                      </span>
                    </p>
                  </div>
                </div>

                <div className="col-lg-6">
                  <div className="position-relative">
                    <img src="/assets/images/about-img.jpg" alt="..." className="w-100 how-it-work-img" />
                  </div>
                </div>
              </div>
            </div>
          </section> */}
          {/* <section className="homepad" id="vision">
            <div className="container">
              <div className="row align-items-center">
                <div className="col-lg-6">
                  <div className="position-relative">
                    <img src="/assets/images/about-img.jpg" alt="..." className="w-100 about-img" />
                  </div>
                </div>
                <div className="col-lg-6 font-size-16 font-weight-normal line-hight-3 text-muted mt-4 mt-lg-0 pt-3 pt-lg-0">
                  <div className="ps-lg-4 ps-xl-5">
                    <div>
                      <div className="bg-primary font-weight-semibold font-size-18 text-capitalize p-1 rounded-pill d-inline-block text-white pe-4">
                        <span className="bg-yellow d-inline-block p-1 bg-primary rounded-pill favicon-logo01 text-center me-2">
                          <img src="/assets/images/favicon-logo01.svg" alt="..." className="rounded-circle" />
                        </span>
                        Our Vision
                      </div>
                    </div>
                  
                   
                    <p className="mt-3">
                      We envision a world where no child is left waiting, where families are equipped with tools—not guesswork—and where communities are empowered to intervene early, effectively, and with compassion.
                      Together, we can build a Just Generation—one child, one family, one breakthrough at a time.
                    </p>
                  </div>
                </div>

                
              </div>
            </div>
          </section> */}

          <section className="homepad pt-0">
            <div className="container">
              <div className="row align-items-center">
                <div className="col-12">
                  <div className="position-relative misson-box overflow-hidden rounded22"
                    style={{
                      backgroundImage: "url('/assets/images/misson-bg.jpg')",
                      backgroundRepeat: "no-repeat"
                    }}
                  >
                    <div className="position-relative align-items-center d-flex p-4 p-lg-5 m-2 m-md-4 m-lg-5">
                      <div className="me-4 misson-icon"><img src="/assets/images/misson-icon.svg" alt="..." className="img-fluid" /></div>
                        <div className="font-size-22 font-weight-normal line-hight-3 text-white ps-lg-4 col-md-9 col-lg-8">
                          <h2 className="font-weight-bold montserrat text-white font-size-44 mb-3 mb-lg-4 line-hight-2">Because Every Child Deserves a Strong Start</h2>
                          At The Just Generation Foundation, we believe early intervention is the key to unlocking every child’s potential. Our platform connects parents, childcare providers, and certified professionals — creating a seamless path to assessments, resources, and support.
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
          </section>
          <section className="homepad pt-0">
            <div className="container">
              <div className="row justify-content-between">
                <div className="col-md-8 col-lg-7 pb-4 pb-lg-5 text-center mx-auto">
                  <h2 className="font-weight-bold montserrat text-primary font-size-50 mb-4 line-hight-2">Empowering Families. Elevating Futures.</h2>
                  <div className="families-btn">
                    <a href="#" className="btn btn-light font-weight-medium font-size-18 text-capitalize px-3 px-md-4 rounded"><span className="d-block py-1">know More</span></a>
                    <a href="#" className="btn btn-light font-weight-medium font-size-18 text-capitalize px-3 px-md-4 rounded mx-2"><span className="d-block py-1">Join Our Network</span></a>
                    <a href="#" className="btn btn-light font-weight-medium font-size-18 text-capitalize px-3 px-md-4 rounded"><span className="d-block py-1">Donate</span></a>
                  </div>
                </div>
              </div>
              
            </div>
          </section>
          <section className="homepad pt-0" id="how-it-work">
            <div style={{ position: "relative", top: "-150px" }} id="how-it-work-anchor"></div>
            <div className="container">
              
              <div className="row">
                <div className="col-lg-8">
                  <h3 className="font-weight-bold montserrat text-primary font-size-40 mb-3 mb-lg-4 pb-lg-1 line-hight-2 text-center text-lg-start">How It Work</h3>
                  <div className="row whychoose-row justify-content-center row-cols-1 row-cols-md-3 g-2 g-md-3 g-xl-4">
                    <div className="col col-transition">
                      <div className="card bg-light border-0 h-100 rounded whychoose-box text-center">
                        <div className="card-body p-3">
                          <div className="p-2">
                            <img src="/assets/images/how-it-work01.svg" alt="..." className="" />
                            <h4 className="font-weight-bold montserrat mb-3 mb-lg-4 pt-1 mt-3 mt-lg-4 text-dark font-size-22 line-hight-1">Sign Up & Verify </h4>
                            <p className="card-text font-size-16 text-muted font-weight-normal line-hight-3">Parents and providers join our secure platform with verified identity checks <br />(powered by eZverifi) </p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col col-transition">
                      <div className="card bg-light border-0 h-100 rounded whychoose-box text-center">
                        <div className="card-body p-3">
                          <div className="p-2">
                            <img src="assets/images/how-it-work02.svg" alt="..." className="" />
                            <h4 className="font-weight-bold montserrat mb-3 mb-lg-4 pt-1 mt-3 mt-lg-4 text-dark font-size-22 line-hight-1">Discover Needs </h4>
                            <p className="card-text font-size-16 text-muted font-weight-normal line-hight-3">Simple screening tools and resources flag early signs of developmental needs </p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col col-transition">
                      <div className="card bg-light border-0 h-100 rounded whychoose-box text-center">
                        <div className="card-body p-3">
                          <div className="p-2">
                            <img src="/assets/images/how-it-work03.svg" alt="..." className="" />
                            <h4 className="font-weight-bold montserrat mb-3 mb-lg-4 pt-1 mt-3 mt-lg-4 text-dark font-size-22 line-hight-1">Connect & Support</h4>
                            <p className="card-text font-size-16 text-muted font-weight-normal line-hight-3">We match families with trusted specialists and track progress together </p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col mt-5 text-center">
                      <h3 className="font-weight-bold text-primary mb-3 lh-base font-size-20">Start The Journey As</h3>
                      <div className="d-flex justify-content-center ">
                      <Link to="/signup">
                        <button className="btn btn-custom-primary font-weight-medium font-size-18 text-capitalize px-3 px-md-4 rounded">Parent </button>
                      </Link>
                      <Link to="/provider/signup">
                        <button className="btn btn-custom-primary font-weight-medium font-size-18 text-capitalize px-3 px-md-4 rounded ms-4">Provider </button>
                      </Link>
                      </div>
                    </div>
                    
                  </div>
                </div>
                <div className="col-lg-4 mt-4 mt-lg-0 pt-2 pt-lg-0">
                  <img src="/assets/images/how-it-work-img.jpg" alt="..." className="w-100 how-it-work-img" />
                </div>
              </div>
            </div>
          </section>
          <section className="homepad border-top">
            <div className="container">
              {/* <div className="row justify-content-between">
                <div className="col-md-8 col-lg-7 pb-4 pb-lg-5 text-center mx-auto">
                  <h2 className="font-weight-bold montserrat text-primary font-size-50 mb-4 line-hight-2">Empowering Families. Elevating Futures.</h2>
                  <div className="families-btn">
                    <a href="#" className="btn btn-danger font-weight-medium font-size-18 text-capitalize px-3 px-md-4 rounded"><span className="d-block py-1">know More</span></a>
                    <a href="#" className="btn btn-light font-weight-medium font-size-18 text-capitalize px-3 px-md-4 rounded mx-2"><span className="d-block py-1">Join Our Network</span></a>
                    <a href="#" className="btn btn-light font-weight-medium font-size-18 text-capitalize px-3 px-md-4 rounded"><span className="d-block py-1">Donate</span></a>
                  </div>
                </div>
              </div> */}
              <div className="row" id="help">
                <div className="col-lg-4 mt-4 mt-lg-0 pt-2 pt-lg-0">
                  <img src="/assets/images/founders-messag-img.jpg" alt="..." className="w-100 testimonials-left-img" />
                </div>
                <div className="col-lg-8">
                  <h3 className="font-weight-bold montserrat text-primary font-size-40 mb-3 mb-lg-4 pb-lg-1 line-hight-2 text-center text-lg-start">Who We Help</h3>
                  <div className="row whychoose-row justify-content-center row-cols-1 row-cols-md-3 g-2 g-md-3 g-xl-4">
                    <div className="col col-transition">
                      <div className="card bg-light border-0 h-100 rounded whychoose-box text-center">
                        <div className="card-body p-3">
                          <div className="p-2">
                            <img src="/assets/images/how-it-work01.svg" alt="..." className="" />
                            <h4 className="font-weight-bold montserrat mb-3 mb-lg-4 pt-1 mt-3 mt-lg-4 text-dark font-size-22 line-hight-1">Parents </h4>
                            <p className="card-text font-size-16 text-muted font-weight-normal line-hight-3">Gain peace of mind with early screenings, trusted referrals, and clear progress tracking</p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col col-transition">
                      <div className="card bg-light border-0 h-100 rounded whychoose-box text-center">
                        <div className="card-body p-3">
                          <div className="p-2">
                            <img src="assets/images/how-it-work02.svg" alt="..." className="" />
                            <h4 className="font-weight-bold montserrat mb-3 mb-lg-4 pt-1 mt-3 mt-lg-4 text-dark font-size-22 line-hight-1">Providers </h4>
                            <p className="card-text font-size-16 text-muted font-weight-normal line-hight-3">Access training, compliance tools, and streamlined support for every child in your care </p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col col-transition">
                      <div className="card bg-light border-0 h-100 rounded whychoose-box text-center">
                        <div className="card-body p-3">
                          <div className="p-2">
                            <img src="/assets/images/how-it-work03.svg" alt="..." className="" />
                            <h4 className="font-weight-bold montserrat mb-3 mb-lg-4 pt-1 mt-3 mt-lg-4 text-dark font-size-22 line-hight-1">Professionals</h4>
                            <p className="card-text font-size-16 text-muted font-weight-normal line-hight-3">Serve families with secure scheduling, virtual sessions, and payment tools built in </p>
                          </div>
                        </div>
                      </div>
                    </div>
                    
                    {/* <div className="col w-50 d-flex justify-content-center">
                      <button className="btn btn-custom-primary font-weight-medium font-size-18 text-capitalize px-3 px-md-4 rounded w-auto text-white mx-4 get-started-button">Get Started </button>
                    </div> */}
                    
                  </div>
                </div>
                {/* <div className="col-lg-4 mt-4 mt-lg-0 pt-2 pt-lg-0">
                  <img src="/assets/images/how-it-work-img.jpg" alt="..." className="w-100 how-it-work-img" />
                </div> */}
              </div>
            </div>
          </section>
          <section className="homepad pb-0 pt-0 col-transition">
  <div className="container">
    <div className="row justify-content-center">
      <div className="col-lg-10">
        <div className="call-to-action-box text-center p-5 rounded shadow">
          <h3 className="font-weight-bold montserrat text-primary font-size-40 mb-4 line-hight-2">
            Ready to Empower Every Child’s Future?
          </h3>
          <div className="families-btn d-flex justify-content-center flex-wrap">
            <a href="#" className="btn btn-light font-weight-medium font-size-18 text-capitalize px-4 py-2 rounded m-2">
              Join the Platform
            </a>
            <a href="#" className="btn btn-light font-weight-medium font-size-18 text-capitalize px-4 py-2 rounded m-2">
              Schedule a Demo
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

          <section className="homepad">
      <div className="container">
        <div className="row mb-4 pb-1">
          <div className="col-12 text-center">
            <div className="bg-primary-heading font-weight-semibold font-size-18 text-capitalize p-1 rounded-pill d-inline-block text-white pe-4">
              <span className="bg-yellow d-inline-block p-1 bg-primary-heading rounded-pill favicon-logo01 text-center me-2">
                <img src="/assets/images/favicon-logo01.svg" alt="..." className="rounded-circle" />
              </span>
              Choose Your Role
            </div>
            <h2 className="font-weight-bold montserrat text-primary font-size-50 my-4 line-hight-2">
              The right care starts with the <br className="d-none d-md-block" />
              right people. Get started
            </h2>
            <p className="font-size-16 text-dark">
              Every child deserves a team of trusted professionals to guide their unique journey. Our platform connects families and childcare centers with a diverse network of licensed experts, each committed to early identification, intervention, and whole-child wellness.
            </p>
          </div>
        </div>

        {/* Carousel + Cards */}
        <div className="carousel-container">
          <div className="owl-carousel owl-theme chooseyour-row" ref={carouselRef}>
            {serviceTypes.map((serviceType) => (
              <a
                href={`/client-services/${serviceType.id}`}
                target="_blank"
                rel="noopener noreferrer"
                key={serviceType.id}
              >
                <div className="card-hover position-relative overflow-hidden">
                  <img
                    src={`${process.env.REACT_APP_SERVICE_TYPE_IMAGE_URL}/${serviceType.image}`}
                    alt={serviceType.issue_type}
                    style={{ height: "500px", objectFit: "cover", width: "100%" }}
                    onError={(e) => {
                      const fallbackImages = [
                        '/assets/images/chooseyour-role01.jpg',
                        '/assets/images/chooseyour-role02.jpg',
                        '/assets/images/chooseyour-role03.jpg',
                      ];
                      const randomIndex = Math.floor(Math.random() * fallbackImages.length);
                      e.target.src = fallbackImages[randomIndex];
                    }}
                  />
                  {/* <img src="/assets/images/chooseyour-role02.jpg" alt={serviceType.issue_type} /> */}
                  <div className="card-overlay position-absolute Bottom-0 start-0 end-0 text-white">
                    <h5 className="font-size-18 font-weight-bold montserrat text-white mb-3 lh-base">
                      {serviceType.issue_type}
                    </h5>
                  </div>
                  <div className="chooseyour-card position-absolute text-white d-flex flex-column p-4">
                    <div className="lh-base font-size-16">
                      <p>
                        “{serviceType.description}”
                      </p>
                    </div>
                    <div className="mt-auto">
                      <h6 className="font-size-18 font-weight-bold montserrat text-white mb-4 line-hight-1">
                        Can help with
                      </h6>
                      <p>{serviceType.issue_type}</p>
                    </div>
                  </div>
                </div>
              </a>
            ))}
          </div>

          {/* Custom Controls */}
          <div className="carousel-controls carousel-arrow text-center mt-4 pt-3">
            <button className="owl-prev bg-white">
              <i className="fa fa-chevron-left" aria-hidden="true"></i>
            </button>
            <a
              href="/signup"
              className="btn btn-custom-primary font-weight-medium font-size-18 text-capitalize px-3 px-md-4 rounded w-auto text-white mx-4"
            >
              <span className="d-block py-2">
                Get Started
                <img src="/assets/images/arrow-01.svg" alt="..." className="ms-2" />
              </span>
            </a>
            <button className="owl-next bg-white">
              <i className="fa fa-chevron-right" aria-hidden="true"></i>
            </button>
          </div>
        </div>
      </div>
    </section>
          <section className="homepad bg-light">
            <div className="container">
              <div className="row align-items-center">
                {/* Left Column */}
                <div className="col-md-7 font-size-16 font-weight-normal line-hight-3 text-muted">
                  <div className="pe-md-2 pe-xl-4">
                    <div className="bg-primary-heading font-weight-semibold font-size-18 text-capitalize p-1 rounded-pill d-inline-block text-white pe-4"><span className="bg-yellow d-inline-block p-1 bg-primary-heading rounded-pill favicon-logo01 text-center me-2"><img src="/assets/images/favicon-logo01.svg" alt="..." className="rounded-circle" /></span>Founder's Message</div>
                    <h2 className="font-weight-bold text-primary font-size-50 my-3 my-lg-4 line-hight-2 montserrat">A Message from Our Founder</h2>
                    <p className="section-text mb-3">
                      The spark behind JGF came from a simple truth: too many children go without the help they need because families don’t know where to start.
                    </p>
                    <p className="section-text">
                      I built this foundation so that no parent ever feels powerless, and no child is left behind in silence.
                      Our platform is not just about technology—it’s about trust, community, and legacy.
                      Together, we can create a just generation: one where early support leads to lifelong strength.
                    </p>
                  </div>
                  <div className="pt-2">
                            <div className="testimonial-author font-weight-bold text-primary font-size-16 mt-4 line-hight-2 montserrat d-flex align-items-center justify-content-center justify-content-md-start">
                              <div>- Babbette Woodbury, Founder</div>
                            </div>
                            <div className="testimonial-author font-weight-bold text-primary font-size-16 mt-2 mb-2 line-hight-2 montserrat d-flex align-items-center justify-content-center justify-content-md-start">
                              <div><i>The Just Generation Foundation</i></div>
                            </div>
                          </div>
                          
                </div>
                {/* Right Column */}
                <div className="col-md-5 text-center mt-4 mt-md-0">
                  <img src="/assets/images/founders-messag-img.jpg" alt="Founder" className="founder-img img-fluid w-100" />
                </div>
              </div>
            </div>
          </section>
          <section className="testimonial-section text-center homepad font-size-16 font-weight-normal line-hight-3 text-muted">
            <div className="container-fluid px-0">
              <div className="row align-items-center m-0">
                <div className="col-md-12">
                  <div className="text-center">
                    <div className="bg-primary-heading font-weight-semibold font-size-18 text-capitalize p-1 rounded-pill d-inline-block text-white pe-4"><span className="bg-yellow d-inline-block p-1 bg-primary-heading rounded-pill favicon-logo01 text-center me-2"><img src="/assets/images/favicon-logo01.svg" alt="..." className="rounded-circle" /></span>Proof & Stories</div>
                  </div>
                  <h2 className="font-weight-bold text-primary font-size-50 my-3 my-lg-4 line-hight-2 montserrat">Real Families. Real Impact</h2>
                  <div className="col-sm-9 col-lg-6 col-xl-5 mx-auto">
                    {/* <p className="text-muted font-size-18">Real Families. Real Impact.</p> */}
                  </div>
                </div>
              </div>
              <div className="row align-items-center mt-md-4 mt-xl-5">
                <div className="col-md-6 mb-4 mb-md-0 d-none d-md-block">
                  <img src="/assets/images/testimonials-left-img.jpg" alt="Group Study" className="img-fluid w-100 testimonials-left-img" />
                </div>
                <div className="col-md-6">
                  <div id="testimonialCarousel" className="carousel slide" data-bs-ride="carousel">
                    <div className="carousel-inner">
                      {/* Testimonial 1 */}
                      <div className="carousel-item active">
                        <div className="testimonial-card text-start position-relative text-center text-md-start">
                          <div className="mb-4 pb-2">
                            <img src="/assets/images/testimonials-img01.png" alt="User" className="profile-img rounded-circle" />
                          </div>
                          {/* <h6 className="font-weight-bold text-primary font-size-24 my-3 my-lg-4 line-hight-2 montserrat position-relative"><i className="fa fa-quote-left position-absolute font-size-50" aria-hidden="true"></i>It was a very good experience</h6> */}
                          <p className="testimonial-text text-primary font-size-22 font-weight-medium mb-0">
                            <em>JGF helped us identify our son’s speech needs before kindergarten. We’re so grateful.</em>
                          </p>
                          <div className="pt-2">
                            <div className="testimonial-author font-weight-bold text-primary font-size-16 mt-4 mb-2 line-hight-2 montserrat d-flex align-items-center justify-content-center justify-content-md-start">
                              <div>Parent, Virginia</div>
                              {/* <div className="star-rating ms-4">
                                <i className="fa fa-star fil"></i>
                                <i className="fa fa-star fil"></i>
                                <i className="fa fa-star fil"></i>
                                <i className="fa fa-star filnone"></i>
                                <i className="fa fa-star filnone"></i>
                              </div> */}
                            </div>
                            {/* <div className="testimonial-role text-gray font-weight-normal">CEO & Founder</div> */}
                          </div>
                        </div>
                      </div>
                      {/* Testimonial 1 */}
                      {/* <div className="carousel-item">
                        <div className="testimonial-card text-start position-relative text-center text-md-start">
                          <div className="mb-4 pb-2">
                            <img src="/assets/images/testimonials-img02.png" alt="User" className="profile-img rounded-circle" />
                          </div>
                          <h6 className="font-weight-bold text-primary font-size-24 my-3 my-lg-4 line-hight-2 montserrat position-relative"><i className="fa fa-quote-left position-absolute font-size-50" aria-hidden="true"></i>It was a very good experience</h6>
                          <p className="testimonial-text text-primary font-size-22 font-weight-medium mb-0">
                            <em>The very fun place went there with my colleagues, and it was so much fun, enjoyed it a lot! The rides & activities were so good, worth every single penny! 👌😄</em>
                          </p>
                          <div className="pt-2">
                            <div className="testimonial-author font-weight-bold text-primary font-size-16 mt-4 mb-2 line-hight-2 montserrat d-flex align-items-center justify-content-center justify-content-md-start">
                              <div>Delene MCnehl</div>
                              <div className="star-rating ms-4">
                                <i className="fa fa-star fil"></i>
                                <i className="fa fa-star fil"></i>
                                <i className="fa fa-star fil"></i>
                                <i className="fa fa-star filnone"></i>
                                <i className="fa fa-star filnone"></i>
                              </div>
                            </div>
                            <div className="testimonial-role text-gray font-weight-normal">CEO & Founder</div>
                          </div>
                        </div>
                      </div> */}
                      {/* Testimonial 1 */}
                      <div className="carousel-item">
                        <div className="testimonial-card text-start position-relative text-center text-md-start">
                          <div className="mb-4 pb-2">
                            <img src="/assets/images/testimonials-img03.png" alt="User" className="profile-img rounded-circle" />
                          </div>
                          {/* <h6 className="font-weight-bold text-primary font-size-24 my-3 my-lg-4 line-hight-2 montserrat position-relative"><i className="fa fa-quote-left position-absolute font-size-50" aria-hidden="true"></i>It was a very good experience</h6> */}
                          <p className="testimonial-text text-primary font-size-22 font-weight-medium mb-0">
                            <em>As a childcare director, I finally have tools to support every child, not just the obvious cases.</em>
                          </p>
                          <div className="pt-2">
                            <div className="testimonial-author font-weight-bold text-primary font-size-16 mt-4 mb-2 line-hight-2 montserrat d-flex align-items-center justify-content-center justify-content-md-start">
                              <div>Provider, Maryland</div>
                              {/* <div className="star-rating ms-4">
                                <i className="fa fa-star fil"></i>
                                <i className="fa fa-star fil"></i>
                                <i className="fa fa-star fil"></i>
                                <i className="fa fa-star filnone"></i>
                                <i className="fa fa-star filnone"></i>
                              </div> */}
                            </div>
                            {/* <div className="testimonial-role text-gray font-weight-normal">CEO & Founder</div> */}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="d-flex justify-content-center justify-content-md-start mt-4 pt-lg-3 carousel-arrow">
                      <button className="carousel-control-prev me-2" type="button" data-bs-target="#testimonialCarousel" data-bs-slide="prev">
                        <i className="fa fa-chevron-left" aria-hidden="true"></i>
                      </button>
                      <button className="carousel-control-next" type="button" data-bs-target="#testimonialCarousel" data-bs-slide="next">
                        <i className="fa fa-chevron-right" aria-hidden="true"></i>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        <ClientFooter />
      </main>
    </>
  );
};

export default ClientHome;
